import Penalties from "./Penalties";
import Penalty from "./Penalty";

export { Penalty, Penalties };
